import React, { useEffect } from "react";
import { Modal, Input, Select, Form } from "antd";
import { TrafficSource, TrafficSourceOrderType } from "./types";
import BasicButton from "../../BasicButton";
import styles from "./styles.module.scss";

interface TrafficSourceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (source: TrafficSource) => Promise<void>;
  initialData?: TrafficSource;
  mode: "add" | "edit";
}

const TrafficSourceModal: React.FC<TrafficSourceModalProps> = ({
  isOpen,
  onClose,
  onSave,
  initialData,
  mode,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialData) {
      form.setFieldsValue(initialData);
    } else {
      form.resetFields();
    }
  }, [initialData, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const updatedSource = {
        ...initialData,
        ...values,
      };
      if (updatedSource.__typename) {
        delete updatedSource.__typename;
      }
      updatedSource.price = parseFloat(String(updatedSource.price));
      await onSave(updatedSource);
      onClose();
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  return (
    <Modal
      title={mode === "add" ? "Add source" : "Edit source"}
      open={isOpen}
      forceRender
      onCancel={onClose}
      width={482}
      footer={null}
    >
      <Form form={form} layout="vertical" className={styles.form}>
        <Form.Item
          label="Order Type"
          name="orderType"
          rules={[{ required: true, message: "Please select the order type" }]}
        >
          <Select
            placeholder="Select order type"
            options={[
              {
                value: TrafficSourceOrderType.DIRECT_INSTALLS,
                label: "Direct installs",
              },
              { value: TrafficSourceOrderType.KEYWORDS, label: "Keywords" },
              { value: TrafficSourceOrderType.RATINGS, label: "Ratings" },
              { value: TrafficSourceOrderType.REVIEWS, label: "Reviews" },
            ]}
          />
        </Form.Item>

        <Form.Item
          label="Platform"
          name="platform"
          rules={[{ required: true, message: "Please select a platform" }]}
        >
          <Select
            placeholder="Select platform"
            // defaultValue={"IOS"}
            options={[
              { value: "IOS", label: "IOS" },
              { value: "ANDROID", label: "ANDROID" },
            ]}
          />
        </Form.Item>

        <Form.Item
          label="Price"
          name="price"
          rules={[{ required: true, message: "Please enter the price" }]}
        >
          <Input prefix="$" type="number" placeholder="Enter price" />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Please enter an email" },
            { type: "email", message: "Please enter a valid email" },
          ]}
        >
          <Input placeholder="Enter email" />
        </Form.Item>

        <Form.Item
          label="Status"
          name="reservationStatus"
          rules={[{ required: true, message: "Please select a status" }]}
        >
          <Select
            options={[
              { value: "DEFAULT", label: "Default" },
              { value: "RESERVE", label: "Reserve" },
            ]}
          />
        </Form.Item>

        <div className={styles.footer}>
          <BasicButton
            onClick={onClose}
            title="Cancel"
            variant="secondary"
            sx={{ flex: 1 }}
          />
          <BasicButton
            onClick={handleSave}
            title={mode === "add" ? "Add" : "Save"}
            variant="primary"
            sx={{ flex: 1 }}
          />
        </div>
      </Form>
    </Modal>
  );
};

export default TrafficSourceModal;
